import styled, { keyframes } from 'styled-components'
import { theme } from '@provi/provi-components'

const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const Overlay = styled.div`
  align-items: center;
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
  justify-content: center;
  display: flex;
  -webkit-animation-name: ${opacity};
  -webkit-animation-duration: 0.25s;
  animation-name: ${opacity};
  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  padding-left: ${({ drawerWidth, isMobile }) => (drawerWidth && !isMobile ? `${drawerWidth}px` : 0)};
  transition: padding 0.5s;
`

const scale = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`

export const Container = styled.div`
  font-family: ${({ fontv2 }) => (fontv2 ? 'Montserrat-Regular' : 'CenturyGothic')}, sans-serif;
  position: relative;
  border-radius: ${({ radius }) => (radius ? `${radius}px` : '20px')};
  max-width: 800px;
  min-height: ${({ isWithoutHeight }) => (isWithoutHeight ? 'unset' : '600px')};
  width: ${({ width }) => width || '90%'};
  z-index: 15;
  top: ${({ isWithoutHeight }) => (isWithoutHeight ? '50px' : 'unset')};
  max-height: 90vh;
  margin-top: 20px;
  box-sizing: border-box;
  background: white;
  display: flex;
  overflow: auto;
  flex-direction: column;
  padding: 25px;
  animation-name: ${scale};
  animation-duration: 0.25s;
  animation-timing-function: ease-out;

  ${theme.breakpoints.down('md')} {
    padding: 16px;
    width: 90%;
  }
`
export const Header = styled.div`
  position: relative;
`
export const Body = styled.div`
  font-family: ${({ fontv2 }) => (fontv2 ? 'Montserrat-Regular' : 'CenturyGothic')}, sans-serif;
  position: relative;
  margin-bottom: 20px;
`

export const Content = styled.div`
  ${theme.breakpoints.down('md')} {
  }
`

export const Title = styled.h3`
  font-family: ${({ fontv2 }) => (fontv2 ? 'Montserrat-SemiBold' : 'CenturyGothicBold')}, sans-serif;
  color: ${theme.colors.blue900};
  font-size: 30px;
  line-height: 36px;
  font-weight: 600;
  font-weight: bold;
  margin: 0;
  margin-bottom: 20px;

  ${theme.breakpoints.down('md')} {
    font-size: 20px;
    line-height: 30px;
  }
`

export const CloseModalWrapper = styled.div`
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  z-index: 100;
  padding-bottom: 10px;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
